

const colorChart = [
	"var(--blue)",
	"var(--green)",
	"var(--yellow)",
	"var(--orange)",
	"var(--purple)"
];

export default colorChart;
